import { NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { FromUntilFormGroup } from './parker-function-from-until-form.types';

@Component({
    selector: 'app-parker-function-from-until-form',
    templateUrl: './parker-function-from-until-form.component.html',
    styleUrls: ['./parker-function-from-until-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, DateTimePickerModule, TranslateModule]
})
export class ParkerFunctionFromUntilFormComponent implements OnInit {
  @Input() public fromUntilForm: FromUntilFormGroup;

  public maxDate = new Date();
  constructor() { }

  ngOnInit() {
  }

}
